"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterItems = exports["default"] = void 0;
var filterItems = exports.filterItems = function filterItems(items, searchTerm) {
  if (!items) {
    return [];
  }
  var filteredItems = [];
  items.forEach(function (item) {
    var found = item.label.toLowerCase().includes(searchTerm.toLowerCase());
    if (!found && item.items) {
      var filteredChildren = filterItems(item.items, searchTerm);
      if (filteredChildren.length > 0) {
        var filteredItem = Object.assign({}, item);
        filteredItem.items = filteredChildren;
        filteredItems.push(filteredItem);
        return;
      }
    }
    return found && filteredItems.push(item);
  });
  return filteredItems;
};
var _default = exports["default"] = filterItems;